<template>
    <div>
        <sys-select-base 
            :model.sync="selected"
            :items="items"
            :loading="loading"
            :label="label"
            :error="error"
            :errors="errors"
            :search.sync="search"
            :clearable="clearable"
            :autoComplete="autoComplete"
            :showAdd="showAdd"
            :disabled="disabled"
            :autofocus="autofocus"
            :dense="dense"
        />
    </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
    name: 'SysSelectUser',
    data: () => ({
        items: [],
        loading: false,
        selected: null,
        search: ''
    }),
    computed: {
        ...mapState('auth', ['acesso'])
    },
    mounted(){
        
    },
    created() {
        if(this.data instanceof Object){
            this.items.push(this.data)
            this.selected = this.model
        } else {
            
            if(!this.model) return

            this.getItems();
        }
    },
    props: {
        
        error: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
        },
        label: {
            type: String,
            required: true
        },
        clearable: {
            type: Boolean,
            default: false
        },
        model: {
        
        },
        dense: {
            type: Boolean,
            default: false
        },
        autoComplete: {
            type: Boolean,
            default: false
        },
        data: {
            required: false
        },
        selectedObject: {
            
        },
        showAdd: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        autofocus: {
            type: Boolean,
            default: false
        },
        
    },
    watch: {
        
        data(val) {
            
            this.items = [];
            
            if(val){
                this.items.push(val);
                this.selected = val.id;
            }
            
        },

        selected(val){
            
            this.$emit('update:model', val);

            if(val && this.selectedObject){
                
                let item = this.items.find(i => i.id == val);
                if(item){
                    this.$emit('update:selectedObject', item);
                }
            }

        },
        
        model(val){
            this.selected = val;
        },
        search(newSearch, oldSearch) {

            this.getItems()
            
        },
    },
    methods: {
        ...mapActions('user', ['ActionFindUsers']),        
        
        async getItems() {

            this.loading = true
            let payload = {
                column_order: 'name',
                direction: 'asc',
                search: this.search,
                find_columns: {
                    active: 1,
                },
                filter_relations: [
                    {
                        name:   'institutions',
                        key:    'id', 
                        value:  this.acesso.instituicao.id,
                    }
                ],
            }

            await this.ActionFindUsers(payload)
                    .then((res) => {
                        this.items = res.data;
                        this.selected = this.model;
                    })
                    .finally(() => {
                        this.loading = false;
                    })
        },

        newItem(item){
            
            if(item){
                this.items.push(item);
                this.selected = item.id;
            }
        }
    },
    
}
</script>